import {gql} from '@apollo/client'

export const IMPORT_BATCH = gql`
  query ImportBatch($id: ID!) {
    importBatch(id: $id) {
      id
      provider
      active
      files {
        uploadId
        filename
        filesize
        status
        failure
        uploadStatus
      }
    }
  }
`

// The import still running after a reload, if any.
export const ACTIVE_IMPORT = gql`
  query ActiveImport {
    activeImport {
      id
      provider
      active
      files {
        uploadId
        filename
        filesize
        status
        failure
        uploadStatus
      }
    }
  }
`
